import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { signIn } from 'next-auth/react';

export default function Redirect() {
  const hasRedirectedToSignIn = useRef(false);
  const router = useRouter();

  const errorMessage = router.query.error;
  let callbackUrl = router.query.callbackUrl ?? '/';

  if (callbackUrl.includes('i18n')) {
    callbackUrl = '/';
  }

  useEffect(() => {
    if (errorMessage) {
      void router.push('/auth/error', { query: { error: errorMessage } });
    } else if (
      typeof callbackUrl === 'string' &&
      !hasRedirectedToSignIn.current
    ) {
      hasRedirectedToSignIn.current = true;

      void signIn('azure-ad', { callbackUrl });
    }
  }, [callbackUrl, errorMessage, router]);

  return null;
}

Redirect.unauth = true;
